module.exports = __webpack_public_path__ + "static/fonts/AppleSDGothicNeoT.c86faaf.ttf";